<h2 mat-dialog-title>{{title}}</h2>

<div mat-dialog-content>

    <div fxLayout="row stretch" fxLayout.xs="column">
      <mat-label [innerHTML]="message"></mat-label>
    </div>
    <div fxLayout="row stretch" fxLayout.xs="column">
      <form [formGroup]="formGroup">
          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-form-field *ngIf="data.TipoAsistencia == 1 || !data.TipoAsistencia" appearance="outline" style="width: 100%;">
              <mat-label *ngIf="!isMotivoInasisSerching">Motivo Inasistencia</mat-label>
              <mat-label *ngIf="isMotivoInasisSerching">Cargando...</mat-label>
              <input matInput type="text" 
                      placeholder="Motivo Inasistencia" 
                      aria-label="Motivo Inasistencia" 
                      formControlName="MotivoInasistencia"
                      [matAutocomplete]="motivoInasistencia">
              <mat-autocomplete #motivoInasistencia="matAutocomplete" [displayWith]="displayMotivo">
                <mat-option *ngFor="let motivo of motivoInasistenciaList" [value]="motivo">
                  {{motivo.Nombre}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
  
          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%;">
              <mat-label>Horas</mat-label>
              <input matInput type="number"(keyup.enter)="saveMotivoInasistencia()" formControlName="HorasAsistencia">
            </mat-form-field>
          </div>
        </form>
    </div>

</div>

<br/>

<div mat-dialog-actions>
    <div fxLayout="row stretch" fxLayout.xs="column">
        <button mat-raised-button color="primary" (click)="onAccept()" class="zb-button">{{buttonAcceptText}}</button>
        <button mat-raised-button color="warn" (click)="onDecline()" class="zb-button">{{buttonCancelText}}</button>
    </div>
</div>